import request from '@/utils/testRequest'
//获取统计的答卷信息
export function getAnswerPaperRecord(data){
  return request({
    url: '/otpApi/business/record/getAnswerPaperRecord?pageNum=' + data.pageNum +'&pageSize=' + data.pageSize,
    method:'POST',
    data: data
  })
}
// 根据学科查询题型及题型数量
export function selQuestionTypeAndNumBySubject(query,token) {
	return request({
		url:'/otpApi/foreign/interface/selQuestionTypeAndNumBySubject?subjectId='+ query.subjectId,
		token:token,
		method: 'get',
		data: query
	})
}

//获取信息
export function getStatisKpInfo(query){
  return request({
    url: '/otpApi/business/record/getStatisKpInfo/'+query.aprId,
    method:'get',
    data: query
  })
}
//试卷
export function queryTreeNoAllSubjectSelect(query) {
  return request({
    url: '/otpApi/business/subject/queryTreeNoAllSubjectSelect',
    method: 'get',
    data: query
  })
}
//平均分的接口
export function getAnswerPaperGpa(data) {
  return request({
    url: '/otpApi/business/record/getAnswerPaperGpa?pageNum=' + data.pageNum +'&pageSize=' + data.pageSize,
    method: 'POST',
    data: data
  })
}
// 用户继续答题
export function continueAnswerQuestions(data) {
	return request({
		url: '/otpApi/business/testPaper/getTPAnswerRecordByUserId?userId='+data.userId+'&paperId='+data.paperId,
		method: 'post',
		data
	})
}
// 新增考试记录
export function CreateAnswerPaperRecord(data) {
	return request({
		url: '/otpApi/business/record/saveAnswerPaperRecord',
		method: 'post',
		data
	})
}
// 新增答题记录
export function CreateAnswerRecord(data) {
	return request({
		url: '/otpApi/business/aqrecord/addAnsQuesRecordResultAnswer',
		method: 'post',
		data
	})
}
// 提交考试记录
export function submitAnswerPaperRecord(data) {
	return request({
		url: '/otpApi/business/record/submitAnswerPaperRecord',
		method: 'post',
		data
	})
}
// 获取考试试卷详情
export function GetTestPaperDetail(query) {
	return request({
		url: '/otpApi/business/testPaper/getTestPaperExamInfoById?paperId='+query.paperId+'&ansRecordId='+query.ansRecordId,
		method: 'get',
		data:query
	})
}

// 将自测模式和练习模式生成试卷
export function addPaperApi(data) {
	return request({
		url: '/otpApi/foreign/interface/addPaper',
		method: 'post',
		data
	})
}

// 获取考试试卷详情
export function getTestPaperApi(data,token) {
	return request({
		url: '/otpApi/business/testPaper/getTestPaperExamInfoById',
		method: 'get',
		token:token,
		params:data
	})
}


// 新增答题记录
export const createAnswerRecord = data => request({ url: '/otpApi/business/aqrecord/addAnsQuesRecord', method: 'post', data })

// 查询考试记录详情
export const getTestPaperDetail = data => request({ url: '/otpApi/business/testPaper/getTPAnswerRecord', method: 'post', data })

// 获取本次考试结果分析
export function testPaperAnalysisByAprId(query,token) {
  return request({
    url: '/otpApi/foreign/interface/testPaperAnalysisByAprId',
	method: 'get',
	token:token,
    params: query
  })
}

// 获取本次考试结果分析
export function testPaperAnalysisByAprIdV2(query,token) {
  return request({
    url: '/otpApi/business/record/testPaperAnalysisByAprId/' + query.ansRecordId,
	method: 'get',
	token:token,
  })
}

// 新增答题记录
export function addAnswerapi(data) {
	return request({
		url: '/otpApi/business/aqrecord/addAnsQuesRecordResultAnswer',
		method: 'post',
		data
	})
}

//  查询用户未做完的试卷
export function getUnSubmitPaperRecord(data) {
	return request({
		url:'/otpApi/business/record/getUnSubmitPaperRecord',
		method: 'POST',
		data
	})
}
//  查询用户未做完的试卷
export function getNotDonePaperRecord(data) {
	return request({
		url:'/otpApi/business/record/getNotDonePaperRecord',
		method: 'POST',
		data
	})
}

// 将题目添加到错题本
export function addWrongQuestion(data) {
	return request({
		url:'/otpApi/business/aqrecord/addWrongQuestion',
		method: 'post',
		params:data
	})
}